// extracted by mini-css-extract-plugin
export default {"Control":"qrXoo_2wVTvWpzwydhkW Xho1STas2OmFniCoEAxd"};